import styled from 'styled-components';
import SimpleButton from '@components/SimpleButton';
import { BUTTONS_TYPE } from '../constants';

const ButtonContainer = styled(SimpleButton)`
  width: ${({ buttonsType }) => buttonsType === BUTTONS_TYPE.INLINE && '50%'};
  overflow-wrap: break-word;
  min-width: 70px;
`;

export default ButtonContainer;
